module.exports = __webpack_public_path__ + "media/images/flags/ke-7a93d3a68644b436c0b10f9d4f418875.svg";